import React from 'react';

function CategoryTabs({ activeTab, setActiveTab }) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6">
      <div className="bg-slate-50 rounded-lg border border-slate-200 p-3">
        <div className="flex flex-wrap gap-2">
          <button
            className={`tab-button ${activeTab === 'all' ? 'active' : ''}`}
            onClick={() => setActiveTab('all')}
          >
            <i className="fas fa-list mr-2"></i>
            All Laws
          </button>
          <button
            className={`tab-button ${activeTab === 'federal' ? 'active' : ''}`}
            onClick={() => setActiveTab('federal')}
          >
            <i className="fas fa-landmark mr-2"></i>
            Federal
          </button>
          <button
            className={`tab-button ${activeTab === 'consumerPrivacy' ? 'active' : ''}`}
            onClick={() => setActiveTab('consumerPrivacy')}
          >
            <i className="fas fa-shield-alt mr-2"></i>
            Consumer Privacy
          </button>
          <button
            className={`tab-button ${activeTab === 'socialMedia' ? 'active' : ''}`}
            onClick={() => setActiveTab('socialMedia')}
          >
            <i className="fas fa-users mr-2"></i>
            Social Media
          </button>
          <button
            className={`tab-button ${activeTab === 'aadc' ? 'active' : ''}`}
            onClick={() => setActiveTab('aadc')}
          >
            <i className="fas fa-code mr-2"></i>
            AADC
          </button>
          <button
            className={`tab-button ${activeTab === 'appStore' ? 'active' : ''}`}
            onClick={() => setActiveTab('appStore')}
          >
            <i className="fas fa-mobile-alt mr-2"></i>
            App Store
          </button>
          <button
            className={`tab-button ${activeTab === 'ageVerification' ? 'active' : ''}`}
            onClick={() => setActiveTab('ageVerification')}
          >
            <i className="fas fa-id-card mr-2"></i>
            Age Verification
          </button>
          <button
            className={`tab-button ${activeTab === 'chatbot' ? 'active' : ''}`}
            onClick={() => setActiveTab('chatbot')}
          >
            <i className="fas fa-robot mr-2"></i>
            AI Chatbot
          </button>
          <button
            className={`tab-button ${activeTab === 'international' ? 'active' : ''}`}
            onClick={() => setActiveTab('international')}
          >
            <i className="fas fa-globe mr-2"></i>
            International
          </button>
        </div>
      </div>
    </div>
  );
}

export default CategoryTabs;
